/**
 * Members wrapper — 用户账号 그룹.
 *
 * - access: 注册审核 (회원가입 심사 / 페어링 발급)
 * - users:  用户账号 (이미 가입 완료된 사용자 목록 + 상세 + PIN reset 등)
 */

import { AccessPage } from './platform/Access';
import { UsersPage } from './platform/Users';

export type MembersSub = 'access' | 'users';

export function MembersPage({ sub }: { sub: MembersSub }) {
  if (sub === 'users') return <UsersPage />;
  return <AccessPage />;
}
